import { FC, useState, memo } from 'react';
import { Box, Image, SimpleGrid, Square } from '@chakra-ui/react';
import isEqual from 'lodash/fp/isEqual';
import { DownloadShareableModal } from './DownloadShareableModal';
import { ShareableSection } from './ShareablesContent';

/**
 * @prop ShareableSection.title string
 * @prop ShareableSection.images
 */

export const ShareablesSection: FC<ShareableSection> = memo(
  ({ images }: ShareableSection): JSX.Element | null => {
    const [isOpen, setIsOpen] = useState(false);
    const initialImage = images && images.length > 0 ? images[0] : undefined;
    const [selectedImage, setSelectedImage] = useState(initialImage);

    const onSelectImage = (index: number): void => {
      setIsOpen(true);
      setSelectedImage(images[index]);
    };

    if (!selectedImage) return null;

    return (
      <Box mt={8}>
        <DownloadShareableModal
          isOpen={isOpen}
          previewUrl={selectedImage.previewUrl}
          horizontalUrl={selectedImage.horizontalUrl}
          squareUrl={selectedImage.squareUrl}
          verticalUrl={selectedImage.verticalUrl}
          title={selectedImage.title}
          altText={selectedImage.altText}
          onClosed={() => setIsOpen(false)}
        />

        <SimpleGrid columns={2} spacing={2}>
          {images.map((image, index) => (
            <Square size="100%" overflow="hidden" key={index}>
              <Image
                cursor="pointer"
                src={image.previewUrl}
                borderRadius="4px"
                onClick={() => onSelectImage(index)}
                alt={image.altText}
              />
            </Square>
          ))}
        </SimpleGrid>
      </Box>
    );
  },
  isEqual
);
